import type { LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import CovidPanel from '../../panel/CovidPanel';
import MandatAnnulationReductionPanel from '../../panel/InformationsRattachement/MandatAnnulationReductionPanel';
import InventairePanel from '../../panel/InventairePanel';
import NumeroEmpruntPanel from '../../panel/NumeroEmpruntPanel';
import PeriodeCouvertePanel from '../../panel/PeriodeCouvertePanel';
import ProjetPanel from '../../panel/ProjetPanel';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';

class ProfilEcritureAnnulationReductionTitreExerciceCourantRecette extends BaseProfilRattachement {
  constructor(anneeExercice: number) {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.ANNUL_REDUC_TITRE_EXE_COURANT;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ANNUL_REDUC;
    this.naturePiece = NATURE_PIECE.RECETTE.ANNUL_REDUC;
    this.typePiece = TYPE_PIECE.RECETTE.CORRECTIF;
    this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.TITRE.CODE;
    this.exerRattachement = anneeExercice.toString();
    this.panels = [
      new CodeProduitLocalPanel(true),
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new MandatAnnulationReductionPanel(true),
      new InventairePanel(),
      new NumeroEmpruntPanel(),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
      // TODO : add "Marche public" optional panel
    ];
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (parseInt(ligne?.exerRattachement, 10) !== parseInt(this.exerRattachement, 10)) {
      errors.push({
        id: `ligneMouvement-exerRattachement-${ligne?.identifiant}`,
        message: "L'exercice de rattachement doit être identique à l'exercice du mouvement",
      });
    }

    if (Number(ligne.pieceOrigine) < 1) {
      errors.push({
        id: `ligneMouvement-idPieceOrigine-${ligne?.identifiant}`,
        message: "L'identifiant de la pièce d'origine doit être supérieur ou égal à 1",
      });
    }

    if (ligne.idLigneOriginePes < 1) {
      errors.push({
        id: `ligneMouvement-idLigneOriginePes-${ligne?.identifiant}`,
        message: "L'identifiant de la ligne d'origine PES doit être supérieur ou égal à 1",
      });
    }

    return errors;
  }
}

export default ProfilEcritureAnnulationReductionTitreExerciceCourantRecette;
